
    import '/vercel/path0/docs/demo/draggable.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"draggable","toc":"menu","filename":"docs/demo/draggable.md","lastUpdated":1767583902000,"nav":{"title":"Demo","path":"/demo"}};